import { Col, Row } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import offerAPI from '~/api/OfferAPI';
import { SVGS } from '~/assets/assetsPath';
import { getNumberWithCommas } from '~/utils';
import styles from './Wallet.module.scss';
import { useSelector } from 'react-redux';
import moment from 'moment';
const cx = classNames.bind(styles);

const Wallet = ({ showAmount }) => {
    const userInfo = useSelector((state) => state.user.userInfo);
    const [count, setCount] = useState({
        wallet: 0,
        wallet_rose: 0,
    });
    const handleGetHistoryWithdraw = async () => {
        try {
            const params = {
                fields: '["$all"]',
            };
            const res = await offerAPI.getHistoryWithdrawAPI(params);

            if (res.code === 200) {
                setCount({
                    wallet: res.results.object.wallet,
                    wallet_rose: res.results.object.wallet_rose,
                });
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        handleGetHistoryWithdraw();
    }, []);
    return (
        <Row className={cx('wallet_container')} gutter={16} justify="center">
            <Col className="gutter-row">
                <div className={cx('tab_wallet_deposit')}>
                    <img src={SVGS.IconWalletTabAmount} alt="" />
                    <div className={cx('name_wallet')}>Service Wallet</div>

                    <div className={cx('amount_wallet')}>
                        {showAmount ? `${getNumberWithCommas(count.wallet || 0)} d` : '**********'}
                    </div>
                    {/* <div className={cx('expired_wallet')}>
                        {count.wallet
                            ? `Expiry date: ${moment(new Date(parseInt(userInfo?.expried_wallet))).format(
                                  'DD/MM/YYYY',
                              )}`
                            : ''}
                    </div> */}
                    {count.wallet && (
                        <div className={cx('expired_wallet')}>
                            Expiry:{' '}
                            {userInfo?.expried_wallet && (
                                <span>{moment(new Date(parseInt(userInfo?.expried_wallet))).format('DD/MM/YYYY')}</span>
                            )}
                        </div>
                    )}
                </div>
            </Col>
            <Col className="gutter-row">
                <div className={cx('tab_wallet_withdraw')}>
                    <img src={SVGS.IconWalletTabAmount} alt="" />
                    <div className={cx('name_wallet')}>Commission Wallet</div>
                    <div className={cx('amount_wallet')}>
                        {showAmount ? `${getNumberWithCommas(count.wallet_rose || 0)} d` : '**********'}
                    </div>
                    <div className={cx('expired_wallet')}>&nbsp;</div>
                </div>
            </Col>
        </Row>
    );
};

export default Wallet;
